import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Globalcontext from "./Globalcontext";

const Globalstates = (props) => {
  const { t, i18n } = useTranslation();

  const [submenu, setsubmenu] = useState("");
  const [newcustsource, setNewcustsource] = useState("");
  const [sanksource, setSanksource] = useState("");
  const [kendrasource, setKendrasource] = useState("");

  // ✅ keep a safe default even if i18n not ready yet
  const [headname, setHeadname] = useState("डॅशबोर्ड");

  const [custlist, setCustlist] = useState([]);
  const [customerData, setCustomerData] = useState({});

  // ✅ update translated title whenever language changes
  useEffect(() => {
    try {
      setHeadname(t("Login.header.dashboard"));
    } catch (e) {
      // fallback remains Marathi
    }
  }, [i18n?.language, t]);

  return (
    <Globalcontext.Provider
      value={{
        submenu,
        setsubmenu,
        newcustsource,
        setNewcustsource,
        sanksource,
        setSanksource,
        kendrasource,
        setKendrasource,
        headname,
        setHeadname,
        custlist,
        setCustlist,
        customerData,
        setCustomerData,
      }}
    >
      {props.children}
    </Globalcontext.Provider>
  );
};

export default Globalstates;
